/* eslint-disable */
<template>
  <div>
    <div class="login">
      <div class="form">
        <div>
          <div class="logo">
            <a href="http://fexspace.com"><img src="../../public/logo-small.png" /></a>
          </div>
          <h3>Welcome, {{ email }}</h3>
          <p class="mb-3">Choose your password</p>
          <form @keypress="send" @submit.prevent>
            <div>
              <input :type="[!reveal2?'password':'text']" placeholder="Password" name="password" v-model="password" />
              <span class="reveal" @click="reveal_password2">
                <i class="fa" :class="{'fa-eye': reveal2, 'fa-eye-slash': !reveal2}"></i>
              </span>
              <span class="error" v-if="error.password">*Required</span>
            </div>
            <div>
              <input :type="[!reveal?'password':'text']" name="password" placeholder="Confirm Password" v-model="con_password" />
              <span class="reveal" @click="reveal_password">
                <i class="fa" :class="{'fa-eye': reveal, 'fa-eye-slash': !reveal}"></i>
              </span>
              <span class="error" v-if="error.con_password">*Required</span>
            </div>
            <div>
              <button type="button" @click="submit">Continue</button>
            </div>
          </form>
          <div class="mfes-trustmark" data-type="102" data-width="80" data-height="33"></div>
        </div>
      </div>
    </div>
    <loading ref="loading"></loading>
  </div>
</template>
<style scoped>
.mb-3 {
    margin-bottom: 15px;
}
.gmail-login {
  cursor: pointer;
  background: #eee;
  box-shadow: 0px 0px 2px #00000012 , 0px 2px 2px #00000024;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  width: 50%;
  height: 50px;
}
.gmail-login span {
  font-weight: normal;
  font-size: 15px;
  margin-left: .8em;
}
.linked-login {
  box-shadow: 0px 0px 2px #00000012 , 0px 2px 2px #00000024;
  cursor: pointer;
  background: #fff;
  display: flex;
  justify-content: center;
  border-radius: 5px;
  align-items: left;
  height: 50px;
  width: 50%;
}
.linked-login span {
  max-width: 105px;
}
.linked-login img.linkedin-img {
  margin-top: 16px;
}
.linked-login .loader {
  margin-top: .3em;
}
.login .form form {
  margin-top: 0;
}
.login {
    justify-content: center;
    height: 100vh;
}
</style>
<script>
import AuthenticationService from '@/services/AuthenticationService'
import loading from '@/components/Loading'
import cookies from '@/services/cookies'
import axios from 'axios'
import { mapMutations } from 'vuex'

export default {
  components: {
    loading
  },
  data () {
    return {
      reveal2: false,
      reveal: false,
      plan: '',
      email: '',
      password: '',
      con_password: '',
      keepme: false,
      name: '',
      error: {
        con_password: false,
        password: false,
        message: false
      },
      country: '',
      post: true,
      linked_loader: false,
      google_loader: false,
      str: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    }
  },
  methods: {
    ...mapMutations([
      'SET_DIRECTORY_CHILDREN',
      'SET_IS_SECURITY_QUESTION'
    ]),
    login_pop (type) {
      if (type === 'gmail') {
        this.google_loader = true
      } else {
        this.linked_loader = true
      }

      let data = {
        type
      }

      AuthenticationService.auth(data).then(res => {
        window.location = res.data.link
      }).catch(err => {
        console.log(err)
      })
    },
    reveal_password2 () {
      this.reveal2 = !this.reveal2
    },
    reveal_password () {
      this.reveal = !this.reveal
    },
    close () {
      this.error.message = false
    },
    setCookie (name, value) {
      var expires = ''
      var date = new Date()
      let time = date.setTime(date.getTime() + (60 * 60 * 1000))
      expires = '; expires=' + time

      if (process.env.VUE_APP_NODE_TYPE === 'production') {
        document.cookie = name + '=' + value + expires + '; domain=.fexspace.com; secure=true;'
      } else {
        if (process.env.VUE_APP_NODE_TYPE == 'development') {
          document.cookie = name + '=' + value + expires + '; path=/'
        }

        if (process.env.VUE_APP_NODE_TYPE == 'devment') {
          document.cookie = name + '=' + value + expires + '; domain=.fexdrive.com; secure=true;'
        }
      }
    },
    send (evt) {
      if (evt.keyCode === 13) {
        this.post = true

        if (this.password === '') {
          this.post = false
          this.error.password = true
        } else {
          this.error.password = false
        }

        if (this.con_password === '') {
          this.post = false
          this.error.con_password = true
        } else {
          this.error.con_password = false
        }

        if (this.post && this.str.test(this.email) && /^[2-3]$/.test(Number(this.plan))) {
          let that = this
          this.$refs.loading.load()

          let data = {
            country: this.country,
            email: this.email,
            plan: this.plan,
            type: 'trial',
            password: this.password
          }

          AuthenticationService.settrialpassword(data)
            .then(res => {
              if (res.data.error === true) {
                that.$refs.loader.close()
                that.setCookie('continue_email', that.email)
                that.$router.push('/continue-login')
              }

              if (res.data.error === false) {
                // User has already chosen a plan redirect him to setup account page
                that.$router.push('/setup-account')
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      }
    },
    submit () {
      this.post = true

      if (this.password === '') {
        this.post = false
        this.error.password = true
      } else {
        this.error.password = false
      }

      if (this.con_password === '') {
        this.post = false
        this.error.con_password = true
      } else {
        this.error.con_password = false
      }

      if (this.post && this.str.test(this.email) && /^[2-3]$/.test(Number(this.plan))) {
        let that = this
        this.$refs.loading.load()

        let data = {
          country: this.country,
          email: this.email,
          plan: this.plan,
          type: 'trial',
          password: this.password
        }

        AuthenticationService.settrialpassword(data)
          .then(res => {
            if (res.data.error === true) {
              that.$refs.loader.close()
              that.setCookie('continue_email', that.email)
              that.$router.push('/continue-login')
            }

            if (res.data.error === false) {
              // User has already chosen a plan redirect him to setup account page
              that.$router.push('/setup-account')
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    isValidURL (string) {
      var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)
      return (res !== null)
    }
  },
  async created () {
    let { data } = await axios({ url: `https://extreme-ip-lookup.com/json`, method: 'GET' })
    // let { ldata } = await axios.get(`https://extreme-ip-lookup.com/json/`)

    if (data === undefined) {
      this.ng = false
      this.country = ''
    } else {
      this.country = data.country
      this.ng = data.country === 'Nigeria'
    }

    let externalScript = document.createElement('script')
    externalScript.setAttribute('src', 'https://cdn.ywxi.net/js/1.js')
    externalScript.async = true
    externalScript.defer = true
    document.body.appendChild(externalScript)
  },
  mounted () {
    // if (this.$route.query.redirect !== undefined) {
    //   if (this.isValidURL(this.$route.query.redirect)) {
    //     cookies.setCookie('redirect', this.$route.query.redirect, 6 * 60 * 60 * 1000)
    //   } else {
    //     cookies.setCookie('redirect', this.$route.query.redirect, 0)
    //   }
    // }

    if (cookies.getCookie('contiune_email') !== '' && cookies.getCookie('continue_email') !== null && cookies.getCookie('continue_email') !== undefined) {
      this.email = cookies.getCookie('continue_email')
      this.plan = cookies.getCookie('continue_plan')
    }

    localStorage.removeItem('current_directory_id')
    localStorage.removeItem('db')
    if (cookies.getCookie('token') !== '' && cookies.getCookie('token') !== null) {
      if (sessionStorage.getItem('status') === 'true') {
        this.$router.push('/')
      }
    }

    this.SET_DIRECTORY_CHILDREN([])
  }
}
</script>
